var map = {
	"./workcase2Other1.jpg": 3426,
	"./workcase2Other2.jpg": 3325,
	"./workcase2Other3.jpg": 7744,
	"./workcase2Other4.jpg": 8675,
	"./workcase2Other5.jpg": 5510,
	"./workcase2Other6.jpg": 1441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9235;